import { CHARGE_TYPE } from "./charge.type";

export interface PaymentInfo {
  _id: string;
  value: number;
  invoiceUrl?: string;
  description: string;
  paymentDate?: string | null;
  dueDate?: string;
  nextDueDate?: string;
  installmentNumber?: number | null;
  installment?: string;
  status?: PAYMENT_STATUS;
  billingType?: BILLING_TYPE;
  planId?: string;
  history?: PaymentHistory[];
  customerId?: string;
  split?: string[];
  externalPaymentId?: string;
  nf?: string;
}

export type PaymentHistory = {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  createdAt: Date;
};


export enum BILLING_TYPE {
  UNDEFINED = "UNDEFINED",
  CREDIT_CARD = "CREDIT_CARD",
  BOLETO = "BOLETO",
  PIX = "PIX",
}

export enum PAYMENT_STATUS {
  PENDING = "PENDING",
  RECEIVED = "RECEIVED",
  CONFIRMED = "CONFIRMED",
  OVERDUE = "OVERDUE",
  REFUNDED = "REFUNDED",
  RECEIVED_IN_CASH = "RECEIVED_IN_CASH",
  REFUND_REQUESTED = "REFUND_REQUESTED",
  REFUND_IN_PROGRESS = "REFUND_IN_PROGRESS",
  CHARGEBACK_REQUESTED = "CHARGEBACK_REQUESTED",
  CHARGEBACK_DISPUTE = "CHARGEBACK_DISPUTE",
  AWAITING_CHARGEBACK_REVERSAL = "AWAITING_CHARGEBACK_REVERSAL",
  DUNNING_REQUESTED = "DUNNING_REQUESTED",
  DUNNING_RECEIVED = "DUNNING_RECEIVED",
  DUNNING_CANCELLED = "DUNNING_CANCELLED",
  AWAITING_RISK_ANALYSIS = "AWAITING_RISK_ANALYSIS",
  RENEGOTIATED = "RENEGOTIATED",
  Inativo = "Inativo"
}

export enum CONTRACT_FINE_TYPE {
  DEPOSIT = "Caução",
  RESCISSION = "Rescisão",
  RECOLLECTOR_TRAVEL = "Deslocamento do Recolhedor",
  KM_OVERAGE = "Excesso de KM",
  PROTECTION = "Acionamento Proteção (Ajuda Participativa) ",
  MAINTENANCE_MISUSE = "Manutenção - Mau Uso",
  LICENSING = "Emplacamento",
  REAL_DRIVER_REMOVAL = "Retirar Real Condutor",
  RADIUS_EXCEEDED = "Raio de Atuação Excedido",
  KEY_REPLACEMENT = "Substituição de Chave/Miolo",
  MOTORCYCLE_THEFT = "Furto ou Roubo de Motocicleta",
  MOTORCYCLE_IMPOUNDMENT = "Apreensão da Motocicleta",
  NO_SHOW = "No Show – Ausência/Atraso",
  UNSCHEDULED_MAINTENANCE = "Manutenção sem Agendamento",
  DEFAULT_BLOCK = "Bloqueio por Inadimplência/Mau Uso ou Velocidade Máxima Excedida",
  UNDEFINED = "Indefinido"
}

export type CreatedInstallments = {
  parceledAmount: number;
  numberInstallments: number;
  installmentValue: number;
  paymentMethod: string;
  createdAt: Date;
  installmentAuthor: string;
  paymentId: string;
  installmentType: TYPE_INSTALLMENTS;
}


export enum TYPE_INSTALLMENTS {
  UNDEFINED = "indefinido",
  WEEKLY = "Semanal",
  TRAFFICFINE = "multa de trânsito",
  RECISINO = "recisão",
  REACTIVATION = "negociação de reativação",
  RENEGOTIATION = "renegociação",
}


export type ContractFinesType = {
  renterId: string;
  description: string;
  installmentOption: number;
  licensePlate: string;
  nextDueDate: string;
  optionsBillingCharge: string;
  optionsSelected?: string;
  value: number;
  reference: CHARGE_TYPE
  paymentType: BILLING_TYPE;
}

export type NegotiationReactivationType = {
  description: string;
  downPayment: string;
  hasRetrievalAndBlocking: boolean;
  installmentNegotiatedValue: number;
  installmentOption: string;
  licensePlate: string;
  maintenanceFineAmount: number;
  negotiationAmount: number;
  nextDueDate: string;
  overdueWeeksValue: number;
  partnerId: string;
  paymentId: string[];
  paymentOptions: string;
  percentualValueSplit: number;
  reference: TYPE_INSTALLMENTS;
  renterId: string;
  revisionFineAmount: number;
  unlinkDate: string;
  valueInstallment: string;
};

export type ConvertDepositType = {
  depositInstallmentId: string;
  installmentDeposit: number;
  installmentOption: string;
  installmentPayments: string[];
  newValueDeposit: number;
  paymentDate: string;
  paymentId: string;
  paymentType: string;
  renterId: string;
  valueDeposit: number;
  valueInstallment: string; // Ajustado para string
};


export interface PaymentFormValues {
  billingType: BILLING_TYPE;
  customer: string;
  description: string;
  dueDate: string;
  installmentId?: string;
  installmentType?: TYPE_INSTALLMENTS;
  installmentValue?: string;
  installments?: string;
  newValue: number;
  nextDueDate?: string;
  paymentId: string;
  paymentMethod: string;
  percentualValueSplit: number;
  renterId: string;
  statusPayment: string;
  totalValue: string;
  value: number;
}